;(function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .directive('sharePrintShop', sharePrintShop)

  function sharePrintShop () {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        art: '<',
        sendInfo: '='
      },
      templateUrl: '/arts/directives/share-print-shop/share-print-shop-directive.html?$$REVISION$$'
    }
  }
})()
